<ngx-spinner
  name="upsSpinner"
  bdColor="rgba(255, 255, 255, 0.8)"
  size="medium"
  color="#321815"
  type="custom"
  [fullScreen]="true">
  <app-spinner></app-spinner>
</ngx-spinner>

@if (isLoading) {
  <div class="spinner-container">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}

<!-- Spinner and Dashboard Section -->
<div class="col-12">

  @if (!isLoader) {
    <div class="card card-body card-gbs-dashboard">
      <span class="list-title">GBS Dashboard</span>
      <app-dynamictable
        [displayedColumns]="mainTableFieldMapping"
        [dataSource]="dataSource"
        [isFromGBS]="true"
        [useManualPaging]="true"
        [totalCount]="totalCount"
        [pageSize]="pageSize"
        [activeFilters]="currentAppliedFilters"
        (openDialog)="openAcceptOrRejectDialog($event)"
        (filterChange)="getAdjustmentDetails(1, 20, $event.filters, false)"
        (paginationChange)="getAdjustmentDetails($event.pageIndex + 1, $event.pageSize, [], $event.isRefresh || false)">
      </app-dynamictable>
    </div>
  }

  <!-- Modal for Details Table -->
  <ng-template #detailsTemplate>
    <div class="custom-modal-overlay">
      <div class="custom-modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Request Details</h4>
          <button
            type="button"
            class="btn btn-warning btn-lg close-btn"
            aria-label="Close"
            (click)="closeDetailsPopup()"
            [disabled]="isLoading">
            <i class="fas fa-window-close"></i>
          </button>
        </div>

        <!-- Top table (Main row) -->
        <div class="modal-body">
          <span class="section-heading">Main Request Info</span>
          <app-dynamictable
            [displayedColumns]="detailTableFieldMapping"
            [dataSource]="invoiceDataSource"
            [isFromGBS]="true"
            [isSearchRequired]="false"
            [isFromBulkUpload]="true">
          </app-dynamictable>
        </div>

        <!-- Bottom table (Child details) -->
        <div class="modal-body">
          <span class="section-heading">Statement Details</span>
          <app-dynamictable
            [displayedColumns]="mainRequestInfo"
            [dataSource]="invoiceDataSource"
            [isFromGBS]="true"
            [isSearchRequired]="false"
            [isFromBulkUpload]="true">
          </app-dynamictable>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Modal Section -->
  <div class="modal-section" [ngClass]="{'loading-disabled': isLoading}">
    <ng-template #template1>
      <div class="modal-header">
        <h4 class="modal-title modal-centered-title">Additional Adjustments Details</h4>
        <button
          type="button"
          class="btn btn-warning btn-lg close-btn"
          aria-label="Close"
          (click)="closePopup1()"
          [disabled]="isLoading">
          <i class="fas fa-window-close"></i>
        </button>
      </div>

      <div class="card card-body card-adjustments">
        <form [formGroup]="firstFormGroup" class="custom-form">
          <div class="form-grid">
            <!-- Invoice Number -->
            <mat-form-field appearance="outline" class="form-field stylish-input">
              <mat-label>Invoice Number</mat-label>
              <input
                matInput
                formControlName="invoiceNumber"
                placeholder="Enter Invoice Number"
                [disabled]="isLoading"
                type="text"
                required>
                @if (firstFormGroup.get('invoiceNumber')?.invalid && (firstFormGroup.get('invoiceNumber')?.touched || firstFormGroup.get('invoiceNumber')?.dirty)) {
                  <mat-error>
                    @if (firstFormGroup.get('invoiceNumber')?.errors?.['required']) {
                      <div>📌 Invoice Number required</div>
                    }
                    @if (firstFormGroup.get('invoiceNumber')?.errors?.['maxlength']) {
                      <div>❗ Max 15 characters</div>
                    }
                    @if (firstFormGroup.get('invoiceNumber')?.errors?.['pattern']) {
                      <div>⚠️ Only integer values allowed</div>
                    }
                  </mat-error>
                }
              </mat-form-field>

              <!-- Statement Number -->
              <mat-form-field appearance="outline" class="form-field stylish-input">
                <mat-label>Statement Number</mat-label>
                <input
                  matInput
                  formControlName="statementNumber"
                  placeholder="Enter Statement Number"
                  [disabled]="isLoading"
                  type="text"
                  required>
                  @if (firstFormGroup.get('statementNumber')?.invalid && (firstFormGroup.get('statementNumber')?.touched || firstFormGroup.get('statementNumber')?.dirty)) {
                    <mat-error>
                      @if (firstFormGroup.get('statementNumber')?.errors?.['required']) {
                        <div>📌 Statement Number required</div>
                      }
                      @if (firstFormGroup.get('statementNumber')?.errors?.['maxlength']) {
                        <div>❗ Max 15 characters</div>
                      }
                      @if (firstFormGroup.get('statementNumber')?.errors?.['pattern']) {
                        <div>⚠️ Only integer values allowed</div>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <!-- Status Dropdown -->
                <mat-form-field appearance="outline" class="form-field full-width stylish-input">
                  <mat-label>Status</mat-label>
                  <mat-select formControlName="status" [disabled]="isLoading">
                    @for (statusOption of statusOptions; track statusOption) {
                      <mat-option [value]="statusOption.value">
                        {{ statusOption.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <!-- Reason/Comments -->
                <mat-form-field appearance="outline" class="form-field full-width stylish-input">
                  <mat-label>Reason/Comments</mat-label>
                  <textarea
                    matInput
                    formControlName="reason"
                    placeholder="Enter your Comments here"
                    [disabled]="isLoading">
                  </textarea>
                  @if (firstFormGroup.get('reason')?.invalid && (firstFormGroup.get('reason')?.touched || firstFormGroup.get('reason')?.dirty)) {
                    <mat-error>
                      @if (firstFormGroup.get('reason')?.errors?.['maxlength']) {
                        <div>📏 Cannot exceed 1000 characters</div>
                      }
                      @if (firstFormGroup.get('reason')?.errors?.['pattern']) {
                        <div>🚫 Invalid characters in comment</div>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </form>

            <div class="button-container">
              <button [disabled]="isLoading" type="button" class="btn-upsbrown-default mt-4" (click)="onNext()">
                @if (isLoading) {
                  <span class="loader"></span>
                }
                @if (!isLoading) {
                  <span>Submit</span>
                }
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
